import { MttaByPriorityDO } from './types';

export const emptyMTTRByPriority: MttaByPriorityDO = {
  p1: { duration: 0, count: 0 },
  p2: { duration: 0, count: 0 },
  p3: { duration: 0, count: 0 },
  p4: { duration: 0, count: 0 },
};

export const responseTimeTargetMap: Record<string, string> = {
  p1: '30 minutes',
  p2: '1 hour',
  p3: '4 hours',
  p4: '1 day',
};
